export const mutations = {
    SET_CONTEXT(state, context) {
        state.context = context;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_APPLICATION_CONFIG(state, config) {
        state.appConfig = config;
    },
    SET_REQUIRES_AUTHENTICATION(state, requiresAuthentication) {
        state.requiresAuthentication = requiresAuthentication;
    },
    MESSAGING_ACTIVE(state, active) {
        state.messagingActive = active;
    },
    ADD_STATUS_MESSAGE(state, message) {
        if (state.messagingActive) {
            state.statusMessages.push(message);
        }
    },
    REMOVE_STATUS_MESSAGE(state) {
        state.statusMessages = state.statusMessages.slice(1);
    },
    REGISTER_FEATURE_TOGGLE(state, toggleId) {
        state.featureToggles.push(toggleId);
    },
    SET_ALERT_MESSAGE(state, { title, message, alertClass, variant, optional, hasSearch, blink = false, adjustAlertWidth = false }) {
        state.alertMessage = { title, message, alertClass, variant, optional, hasSearch, blink, adjustAlertWidth };
    },
    SET_APPLICATION_INSIGHTS(state, insights) {
        state.insights = insights;
    },
    SET_SHARED_USERMAP_GUID(state, guid) {
        state.sharedUserMapGuid = guid;
    },
    SET_USERMAP_MESSAGE(state, message) {
        state.userMapMessage = message;
    }
};
